import { render, staticRenderFns } from "./ScrollCarousel.vue?vue&type=template&id=5d018f41&scoped=true&"
import script from "./ScrollCarousel.vue?vue&type=script&lang=js&"
export * from "./ScrollCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ScrollCarousel.vue?vue&type=style&index=0&id=5d018f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d018f41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d018f41')) {
      api.createRecord('5d018f41', component.options)
    } else {
      api.reload('5d018f41', component.options)
    }
    module.hot.accept("./ScrollCarousel.vue?vue&type=template&id=5d018f41&scoped=true&", function () {
      api.rerender('5d018f41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/ScrollCarousel.vue"
export default component.exports